import React from 'react'
import PropTypes from 'prop-types'
import Modal from '@components/common/Modal'
import Select from '@components/common/Select'
import ColorPicker from '@components/ColorPicker'
import DatePicker from '@components/DatePicker'
import { Dropdown, Input, Radio } from 'antd'
import classnames from 'classnames'
import Popover from '@components/common/Popover'
import _ from 'lodash'
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc'

import GradationStyle, { SQUARE_GRADATION_COLORS, CUBE_GRADATION_COLORS, getGradationBackground } from './GradationStyle'
import BarStyle, { getBarBackground } from './BarStyle'

import {
  GRADATION,
  BAR,
  ITEM_CLASS,
  shouldCancelStart,
  getOperatorByField,
  CONFIG_TYPES,
  ICON_ALIGN,
  GRADATION_TYPES,
  BAR_TYPES,
  DIM_OPERATORS,
  NUM_OPERATORS,
  DATE_OPERATOR_TYPES,
  DEFAULT_FONT_ICON,
  DEFAULT_ICON_COLOR,
  DEFAULT_ICON_LIST,
  isNullType,
  isMultiple,
  generateConditionOptions,
  _generateFilterOption,
  getBarColor,
} from './helper'

import './icon/iconfont.css'
import cssStyles from './cells-config.module.less'

const noDataTip = (<div className="no-data">没有找到相关数据</div>)

class CellsConfig extends React.Component {
  static propTypes = {

    chart: PropTypes.object,
    data: PropTypes.array,
    onChange: PropTypes.func,
    fetchFieldOptions: PropTypes.func,
  }
  constructor(props) {
    super(props)
    this.enableHidden = false
    let dims = (props.chart && props.chart.dims) || []
    const comparisons = (props.chart && props.chart.comparisons) || []
    const nums = (props.chart && props.chart.nums) || []
    const aggregation = props.chart && props.chart.data.aggregation
    //明细
    if (!aggregation) {
      dims = dims.concat(comparisons)
    }
    const config = generateConditionOptions(dims, nums, props.data)
    this.state = {
      conditions: config.data,
      fields: config.fields,
      fieldsOption: {},
      dragToIndex: -1,  //拖动后的index
      currentIndex: -1, //拖动前index
      dragItem: null,
    }
  }
  fetchFieldOption = (fields) => {
    const { fetchFieldOptions } = this.props
    const { fieldsOption } = this.state
    const setStateCallback = (id, colName, json) => {
      if (json.result) {
        fieldsOption[id] = _generateFilterOption(json.data.data, colName)
        this.setState({
          fieldsOption
        })
      }
    }
    if (typeof fetchFieldOptions === 'function') {
      const dimList = _.filter(fields, c => c.col_type === 'dim')
      dimList.forEach((dim) => {
        if (!fieldsOption[dim.dataset_field_id]) {
          fetchFieldOptions({ id: dim.dataset_field_id }, (json) => {
            setStateCallback(dim.dataset_field_id, dim.col_name, json)
          })
        }
      })
    }
  }
  componentWillMount() {
    this.fetchFieldOption(this.state.fields)
    document.addEventListener('wheel', this.closeDropdown)
    document.addEventListener('click', this.clickBody)
  }
  componentWillReceiveProps(nextProps) {
    if (!(_.isEqual(nextProps.chart.dims, this.props.chart.dims) &&
    _.isEqual(nextProps.chart.nums, this.props.chart.nums) && _.isEqual(nextProps.chart.comparisons, this.props.chart.comparisons))) {
      let dims = (nextProps.chart && nextProps.chart.dims) || []
      const comparisons = (nextProps.chart && nextProps.chart.comparisons) || []
      const nums = (nextProps.chart && nextProps.chart.nums) || []
      const aggregation = nextProps.chart && nextProps.chart.data.aggregation
      //明细
      if (!aggregation) {
        dims = dims.concat(comparisons)
      }
      const config = generateConditionOptions(dims, nums, nextProps.data)
      this.fetchFieldOption(config.fields)
      this.setState({
        conditions: config.data,
        fields: config.fields
      })
    }
  }
  componentWillUnmount() {
    document.removeEventListener('wheel', this.closeDropdown)
    document.removeEventListener('click', this.clickBody)
  }
  render() {
    const { visible, conditions } = this.state
    return (
      <div className="diagram-design-config-content">
        <div className="layout-config-column-custom cells-config">
          <span className="layout-config-column-title cells-config-title" style={{ fontSize: '14px', height: '30px' }}>
            配置设置
          </span>
          <div className='cells-config-component'>
            {
              conditions.length > 0 && <div className="delete-handler"><button type='button' onClick={this.removeConfigs} >
                <i className='iconfont icon-recycle-bin' />
              </button></div>
            }
            <div className="handler">
              <button type='button' onClick={this.showDialog}>
                <i className='iconfont-date-filter icon-date-filter-edit' />
              </button>
            </div>
            <Modal
              maskClosable={false}
              wrapClassName='cells-config-dialog'
              maskStyle={{
                backgroundColor: 'rgba(0, 0, 0, 0.45)'
              }}
              width={725}
              title="条件格式配置"
              cancelText='取消'
              okText='保存'
              okType={'primary'}
              visible={visible}
              onOk={this.handleOk}
              onCancel={this.hideDialog}
            >
              <div className="cells-config-wrapper" ref={(node) => { this.layerList = node }}>
                <div className="cells-config-button-wrapper">
                  <span>
                    <i onClick={this.addCondition} className="iconfont icon-plus1"/>
                    配置条件
                  </span>
                </div>
                {this.renderCellsConfigList()}
              </div>
            </Modal>
          </div>
        </div>
        {
          conditions.length > 0 && <div className="layout-config-column-custom cells-config">
            {
              this.renderConditionsList()
            }
          </div>
        }
      </div>
    )
  }
  handleOk = () => {
    this.setState({
      visible: false,
    }, () => {
      this.props.onChange(this.state.conditions.map(d => ({ ...d, visible: false })))
    })
  }
  showDialog = () => {
    const state = {
      visible: true
    }
    this.setState(state)
  }
  hideDialog = () => {
    const { chart, data } = this.props
    let dims = (chart && chart.dims) || []
    const comparisons = (chart && chart.comparisons) || []
    const nums = (chart && chart.nums) || []
    const aggregation = chart && chart.data.aggregation
    //明细
    if (!aggregation) {
      dims = dims.concat(comparisons)
    }
    const config = generateConditionOptions(dims, nums, data)
    //如果取消则恢复原来的值
    this.setState({
      conditions: config.data,
      fields: config.fields,
      visible: false
    })
  }

  removeConfigs = () => {
    //清空所有配置
    Modal.confirm({
      title: '确定要删除条件格式配置？',
      content: '将删除已配置的条件格式,可以通过页面顶部撤销功能撤回删除操作,请知晓并确认操作风险',
      width: 500,
      className: 'variable-bind-delete-confirm-dialog',
      onOk: () => {
        this.setState({
          conditions: []
        }, () => {
          this.props.onChange([])
        })
      },
      onCancel() { },
    })
  }
  addCondition = () => {
    const { conditions, fields } = this.state
    //日期类型新增默认值
    const newCondition = {
      dataset_field_id: fields[0] ? fields[0].dataset_field_id : '',
      col_name: fields[0] ? fields[0].alias : '',
      col_type: fields[0] ? fields[0].col_type : '',
      field_type: fields[0] ? fields[0].data_type : '',
      type: 'style',
      date_operator_type: 'static',
      daysValue: 7,
      dynamic_date: '',
      range_date: [],
      operator: '=',
      value: [],
      effect_options: {
        way: 'default',
        lists: []
      },
      order: conditions.length,
      visible: false,
      rangeVisible: false,
      styles: {
        color: '#F0454C',
        background: '#FCD7D2',
        icon: 'default',
        icon_align: 'left',
        hide: false,
        gradation_colors: [],
      }
    }
    conditions.push(newCondition)
    this.setState({
      conditions
    })
  }

  removeCondition = (index) => {
    const { conditions } = this.state
    conditions.splice(index, 1)
    this.setState({
      conditions
    })
  }

  closeDropdown = () => {
    const { conditions } = this.state
    if (conditions.length <= 0 || conditions.every(d => !d.visible) || conditions.every(d => !d.rangeVisible)) return

    conditions.forEach((c) => {
      c.visible = false
      c.rangeVisible = false
    })
    this.enableHidden = false
    this.handleHideColorPickerPopover()
    this.setState({
      conditions
    })
  }

  renderConditionsList = () => {
    const { conditions } = this.state
    return (
      <div className="cells-config-conditions">
        <ul>
          {
            conditions.map((condition, index) => {
              const { styles, type, value } = condition
              const { icon, color, gradation_colors: gradationColors } = styles
              const currentColor = color || '#F0454C'
              const currentBg = type === GRADATION ? getGradationBackground(gradationColors) : (type === BAR ? getBarBackground(gradationColors, value === GRADATION) : ('#fff'))
              const wrapperClassName = classnames({
                'config-icon-wrapper': type !== GRADATION && type !== BAR,
                'no-border': false,
                'config-gradation-wrapper': type === GRADATION || type === BAR
              })
              return (<li key={`cells-config-condition-${index}`} className="cells-config-condition">
                <span style={{ float: 'left' }}>{condition.col_name}</span>
                <span className={wrapperClassName} style={{ background: currentBg, float: 'right' }}>
                  {icon && <i className={`iconfont-date-filter icon-date-filter-${icon}`} style={{ color: currentColor }}/>}
                </span>
              </li>)
            })
          }
        </ul>
      </div>
    )
  }

  SortableItem = SortableElement(({ item, order }) => this.renderCellConfig(item, order))

  SortableList = SortableContainer(({ conditions }) => {
    const { SortableItem } = this

    return (
      <div className='cells-config-conditions-wrapper'>
        <div className="cells-config-conditions-items" ref={(node) => { this.conditionsWrapper = node }}>
          {
            conditions.map((item, index) => SortableItem && <SortableItem order={index} key={`${item.dataset_field_id}_${index}`} item={item} index={index}/>)
          }
        </div>
      </div>
    )
  })

  renderCellsConfigList = () => {
    const { SortableList } = this

    const { conditions } = this.state

    if (conditions.length === 0) {
      return (
        <div className='cells-config-conditions-wrapper'>
          <div className="cells-config-empty">
            <div><span className="empty-icon"/></div>
            <div>暂时还未设置条件</div>
          </div>
        </div>
      )
    }
    if (!SortableList) return null
    return (
      <SortableList
        shouldCancelStart={shouldCancelStart}
        onSortEnd={this.onSortEnd}
        helperClass="table-cell-style-config-sort-item"
        conditions={conditions}/>
    )
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(({ conditions }) => {
      const newConditions = arrayMove(conditions, oldIndex, newIndex)
      newConditions.forEach((c, index) => { c.order = index })
      return {
        conditions: newConditions,
      }
    })
  }

  renderCellConfig = (item, index) => {
    const { fields } = this.state

    return (
      <div
        key={`${item.dataset_field_id}_${index}`}
        className={`${cssStyles.cellsConfigItem} ${ITEM_CLASS}`}
      >
        <i className="draggable-icon"/>
        <div className="cell" style={{ marginLeft: 32, marginRight: 8, width: 80, flex: 0, flexShrink: 0 }}>
          <Select
            getPopupContainer={() => this.conditionsWrapper || document.body}
            value={item.type}
            maxHeight={104}
            style={{ height: 32, width: 80 }}
            onChange={this.onSelectChange.bind(this, item, index, 'type')}
          >
            { CONFIG_TYPES.map((type, i) => (<Select.Option
              disabled={(type.value === GRADATION || type.value === BAR) && fields.every(d => d.col_type !== 'num')}
              key={`config-types-${i}`}
              value={type.value}>
              <span className={ item.type !== type.value ? 'active' : '' } style={{ backgroundImage: `url(${type.icon})` }}/>
              <span className={ item.type === type.value ? 'active' : '' }  style={{ backgroundImage: `url(${type.activeIcon})` }}/>
              {type.name}
            </Select.Option>))}
          </Select>
        </div>
        <div className="cell" style={{ width: 130, flex: 0, flexShrink: 0 }}>
          <Select
            dropdownMatchSelectWidth={false}
            getPopupContainer={() => this.conditionsWrapper || document.body}
            value={item.col_name}
            maxHeight={104}
            style={{ height: 32, width: 120 }}
            dropdownStyle={{ minWidth: 120, maxWidth: 256 }}
            onChange={this.onSelectChange.bind(this, item, index, 'col_name')}
          >
            {fields.map((f, i) => <Select.Option
              disabled={(item.type === GRADATION || item.type === BAR) && f.col_type !== 'num'} // 维度字段禁用
              key={i}
              value={f.alias}>
              {f.alias}
            </Select.Option>)}
          </Select>
        </div>
        {this.renderOperatorItem(item, index)}
        {this.renderConditionsValue(item, index)}
        {
          this.renderStyleConfig(item, index)
        }
        {
          this.renderEffectRange(item, index)
        }
        <i onClick={this.removeCondition.bind(this, index)} className="condition-remove iconfont icon-recycle-bin"/>
      </div>
    )
  }

  onSelectChange = (item, index, key, option) => {
    const { conditions, fields } = this.state

    switch (key) {
      case 'type': {
        let newStyles = {
          ...conditions[index].styles
        }

        // 重置 operator, value
        let  { operator, value } = conditions[index]
        const { type, col_name } = conditions[index]
        if ((type === GRADATION || type === BAR)) {
          const fieldItem = _.find(fields, f => f.alias === col_name)
          operator = getOperatorByField(fieldItem)
          value = []
        }

        if (option === 'style') {
          //需要重置样式
          newStyles = {
            ...newStyles,
            ...DEFAULT_FONT_ICON[0],
            color: DEFAULT_FONT_ICON[0].color,
            background: DEFAULT_FONT_ICON[0].background,
          }
          conditions[index] = {
            ...conditions[index],
            operator,
            value,
            type: option,
            styles: newStyles,
            effect_options: {
              way: 'default',
              lists: []
            }
          }
        } else if (option === 'icon') {
          newStyles = {
            ...newStyles,
            icon: DEFAULT_ICON_LIST[0].icon,
            color: '#F0454C',
            background: '',
            icon_align: 'left',
            hide: false
          }
          conditions[index] = {
            ...conditions[index],
            operator,
            value,
            type: option,
            styles: newStyles
          }
        } else if (option === GRADATION || option === BAR) {
          let field = null
          if (conditions[index].col_type !== 'num') {
            field = fields.find(d => d.col_type === 'num') || null
            field = {
              dataset_field_id: field ? field.dataset_field_id : '',
              col_name: field ? field.alias : '',
              col_type: field ? field.col_type : '',
              field_type: field ? field.data_type : '',
            }
          }

          conditions[index] = {
            ...conditions[index],
            ...field,
            operator: option === GRADATION ? 'square' : 'auto', // 存储 2 阶, 3 阶 cube
            type: option,
            value: option === GRADATION ? ['min', 'max'] : 'plain', // 条形 -> 单色/渐变,
            styles: {
              ...newStyles,
              color: option === GRADATION ? '#333740' : getBarColor(),
              gradation_colors: option === GRADATION ? [...SQUARE_GRADATION_COLORS[0]] : ['rgba(251, 206, 79, 1)', 'rgba(69, 173, 255, 1)'], // todo
              icon: 'default',
            }
          }
        }
      }
        break
      case 'col_name': {
        const fieldItem = _.find(fields, f => f.alias === option)
        if (fieldItem && option !== conditions[index].col_name) {
          const defaultOption = {
            date_operator_type: 'static',
            daysValue: 7,
            dynamic_date: '',
            range_date: [],
            operator: '=',
            value: []
          }

          defaultOption.operator = getOperatorByField(fieldItem)

          // 色阶类的操作类型
          if (conditions[index].type === GRADATION) {
            defaultOption.operator = 'square'
            defaultOption.value = ['min', 'max']
            defaultOption.styles = {
              ...conditions[index].styles,
              color: '#333740',
              gradation_colors: [...SQUARE_GRADATION_COLORS[0]]
            }
          }

          if (conditions[index].type === BAR) {
            defaultOption.operator = 'auto'
            defaultOption.value = 'plain'
            defaultOption.styles = {
              ...conditions[index].styles,
              color: getBarColor(),
              gradation_colors: ['rgba(251, 206, 79, 1)', 'rgba(69, 173, 255, 1)']
            }
          }

          conditions[index] = {
            ...conditions[index],
            ...defaultOption,
            col_name: option,
            col_type: fieldItem.col_type,
            field_type: fieldItem.data_type,
            dataset_field_id: fieldItem.dataset_field_id,
            effect_options: {
              way: 'default',
              lists: []
            }
          }
        }
      }
        break
      case 'operator': if (option !== conditions[index][key]) {
        conditions[index][key] = option
        conditions[index].value = []
      }
        break
      case 'date_operator_type':
        this.setState((prevState) => {
          const { conditions: preConditions } = prevState
          // 更新时间相关的其他字段
          preConditions[index] = {
            ...preConditions[index],
            date_operator_type: option,
            dynamic_date: '',
            daysValue: 7,
            daysOperator: 'far',
            range_date: [],
          }
          // 更新colValue和operator
          preConditions[index] = {
            ...preConditions[index],
            ...this._getOperatorFromDateDescription(preConditions[index])
          }
          return { conditions }
        })
        break
      case 'barOperator': {
        const condition = conditions[index]
        conditions.splice(index, 1, {
          ...condition,
          operator: option,
        })
        this.setState({
          conditions,
        })
        break
      }
      case 'effect_options':
        this.setState((prevState) => {
          const { conditions: preConditions } = prevState
          // 更新时间相关的其他字段
          preConditions[index][key].lists = option
          return { conditions: preConditions }
        })
        break
      default:
        break
    }
    this.setState({
      conditions
    })
  }

  onAlignChange = (index, key, option) => {
    const { conditions } = this.state
    conditions[index].styles[key] = option
    this.setState({
      conditions
    })
  }

  handleNumChange = (index, key, e) => {
    const newValue = e.target.value
    this.setState((prevState) => {
      const { conditions } = prevState
      let newColValue = conditions[index].value
      switch (key) {
        case 'min':
          newColValue[0] = newValue
          break
        case 'max':
          newColValue[1] = newValue
          break
        case 'value':
          newColValue = [newValue]
          break
        default:
          break
      }
      conditions[index] = {
        ...conditions[index],
        value: newColValue
      }
      const newState = { conditions }
      if (conditions.every((o) => {
        const { operator, value } = o
        const isNull = operator === 'is null' || operator === 'is not null'
        const isBetween = operator === 'between' && value.length > 1
        const notBetween = operator && operator !== 'between' && value.length > 0
        return !!(isNull || isBetween || notBetween)
      })) {
        newState.error_tips = ''
      }
      return newState
    })
  }

  handleDimChange = (index, multiple, option) => {
    const newValue = []
    if (multiple) {
      option.forEach(v => newValue.push(v))
    } else {
      newValue.push(option)
    }
    this.setState((prevState) => {
      const { conditions } = prevState
      conditions[index] = {
        ...conditions[index],
        value: newValue
      }
      return { conditions }
    })
  }

  handleGradationTypeChange(index, option) {
    const { conditions } = this.state
    if (conditions[index].operator === option) return

    const newConditions = [...conditions]
    newConditions[index] = {
      ...newConditions[index],
      operator: option,
      value: option === 'cube' ? ['min', 'median', 'max'] : ['min', 'max'],
      styles: {
        ...conditions[index].styles,
        color: '#333740', // color
        gradation_colors: [...(option === 'cube' ? CUBE_GRADATION_COLORS : SQUARE_GRADATION_COLORS)[0]]
      },
    }

    this.setState({
      conditions: newConditions,
    })
  }

  generateIcon = (color, background, icon, selected, type) => {
    const wrapperClassName = classnames({
      selected,
      'config-icon-wrapper': true,
      'no-border': type === 'icon' && !selected
    })
    return (
      <span className={wrapperClassName} style={{ background }}>
        {icon && <i className={`iconfont-date-filter icon-date-filter-${icon}`} style={{ color }}/>}
      </span>
    )
  }

  renderStyleConfig = (item, index) => {
    const { styles, type, visible } = item
    const currentColor = styles.color || '#F0454C'
    const currentBg = styles.background || 'transparent'

    if (item.type === GRADATION) {
      return <GradationStyle
        condition={item}
        index={index}
        handleChangeVisible={this.handleChangeVisible.bind(this, index, 'visible')}
        onColorPickerHide={this.handleHideColorPickerPopover}
        onColorPickerSure={this.handleConfirmColorChange}
        onGradationChange={this.handleConfirmGradationChange}
      />
    }

    if (item.type === BAR) {
      return <BarStyle
        condition={item}
        index={index}
        handleChangeVisible={this.handleChangeVisible.bind(this, index, 'visible')}
        onColorPickerHide={this.handleHideColorPickerPopover}
        onColorPickerSure={this.handleConfirmColorChange}
        onBarChange={this.handleConfirmBarChange}
      />
    }

    const cn = classnames('icon-checkbox', { checked: styles.hide })
    const configMenu = (
      <div className={`cells-dropdown-overlay style-${type}`} style={{ height: type === 'icon' ? '320px' : '144px' }} >
        <div className="default-color-option" style={{ height: type === 'style' ? '44px' : '88px' }}>
          <ul>
            {type === 'style' && DEFAULT_FONT_ICON.map((i, _index) => {
              const isSelected = i.color === styles.color && i.background === styles.background
              return (
                <li onClick={this.handleChangeStyle.bind(this, index, i, type)} key={`render-style-config-${_index}`}>
                  {this.generateIcon(i.color, 'transparent', i.icon, isSelected, type)}
                </li>
              )
            })}
            {
              type === 'icon' && DEFAULT_ICON_LIST.map((i, _index) => {
                const isSelected = i.icon === styles.icon
                return (
                  <li onClick={this.handleChangeStyle.bind(this, index, i, type)} key={`render-style-icon-config-${_index}`}>
                    {this.generateIcon(i.color, i.background, i.icon, isSelected, type)}
                  </li>
                )
              })
            }
          </ul>
        </div>
        {
          type === 'icon' && <div className="default-color-option" style={{ height: '40px', border: 'none' }}>
            <ul>
              {
                DEFAULT_ICON_COLOR.map((i, _index) => {
                  const isSelected = i.background === styles.color
                  return (
                    <li onClick={this.handleChangeStyle.bind(this, index, i, type)} key={`render-style-icon-color-config-${_index}`}>
                      {this.generateIcon(i.color, i.background, i.icon, isSelected, type)}
                    </li>
                  )
                })
              }
            </ul>
          </div>
        }
        {type === 'icon' && <div className="custom-color-option" style={{ height: '60px', borderBottom: '1px solid #EBEDF0' }}>
          <div className="custom-option-title">
            自定义颜色
          </div>
          <div className="custom-option-config">
            <Popover
              content={
                <ColorPicker
                  color={styles.color || 'transparent'}
                  changeAtOnce={false}
                  onSure={this.handleConfirmColorChange.bind(this, index, 'color')}
                  onHide={this.handleHideColorPickerPopover}
                  disableAlpha={false}
                />
              }
              trigger="click"
              overlayStyle={{ zIndex: 1060 }}
              placement="bottomLeft"
              className="table-cell-config-color-picker-popover-container"
            >
              <div style={{ float: 'left' }}>
                <span className={`custom-option-round ${!styles.color ? 'no-color' : ''}`} style={{ background: styles.color || 'transparent' }}/>
              </div>
            </Popover>
          </div>
        </div>}
        {type === 'style' && <div className="custom-color-option">
          <div className="custom-option-title">
            自定义颜色
          </div>
          <div className="custom-option-config">
            <div className="custom-option-config-title"><span>文字</span></div>
            <Popover
              content={
                <ColorPicker
                  color={styles.color || 'transparent'}
                  changeAtOnce={false}
                  onSure={this.handleConfirmColorChange.bind(this, index, 'color')}
                  onHide={this.handleHideColorPickerPopover}
                  disableAlpha={false}
                />
              }
              trigger="click"
              overlayStyle={{ zIndex: 1060 }}
              placement="bottomLeft"
              className="table-cell-config-color-picker-popover-container"
            >
              <div style={{ float: 'left' }}>
                <span className={`custom-option-round ${!styles.color ? 'no-color' : ''}`} style={{ background: styles.color || 'transparent' }}/>
              </div>
            </Popover>
          </div>
        </div>}
        {
          type === 'icon' && <div className="icon-align-option">
            <div className="icon-align-title">
              <span>位置</span>
              <Select
                getPopupContainer={() => document.body}
                value={styles.icon_align || 'left'}
                maxHeight={104}
                dropdownClassName="gradation-value-select-dropdown"
                style={{ height: 28, width: 88 }}
                onChange={this.onAlignChange.bind(this, index, 'icon_align')}
              >
                { ICON_ALIGN.map((align, i) => (<Select.Option
                  key={`icon-align-${i}`}
                  value={align.value}>
                  {align.text}
                </Select.Option>))}
              </Select>
            </div>
            <div className="icon-align-title" >
              <span>隐藏文字</span>
              <span className="checkbox-wrapper"
                onClick={this.onAlignChange.bind(this, index, 'hide', !styles.hide)}>
                <i className={cn} style={{ margin: '-2px 0 0 1px' }} />
              </span>
            </div>
          </div>
        }
      </div>
    )
    return (
      <div className="cell" style={{ width: 50, flex: 0, flexShrink: 0 }}>
        <Dropdown
          trigger={['click']}
          overlay={configMenu}
          placement='bottomLeft'
          visible={visible}
          onVisibleChange={this.handleChangeVisible.bind(this, index, 'visible')}
        >
          <div className="config-style-wrapper">
            {
              this.generateIcon(currentColor, type === 'style' ? 'transparent' : currentBg, styles.icon)
            }
          </div>
        </Dropdown>
      </div>
    )
  }


  renderEffectRange = (item, index) => {
    const { fields } = this.state
    const { rangeVisible, type, effect_options } = item
    const { way, lists } = effect_options || {}
    const radioStyle = {
      fontSize: '12px',
      padding: '8px',
      width: '100%',
      color: '#333740'
    }
    const configMenu = (
      <div className="cells-dropdown-overlay style-effect-range" style={{ height: way !== 'custom' ? '143px' : '184px' }}>
        <div className="effect-range-options ">
          {
            ['icon', 'style'].indexOf(type) > -1 && <Radio.Group onChange={this.onChangeEffectRange.bind(this, index)} value={way || 'default'}>
              <Radio style={radioStyle} value='default'>
                <span style={{ fontWeight: 'normal' }}>默认</span>
              </Radio>
              <Radio style={radioStyle} value='line'>
                <span style={{ fontWeight: 'normal' }}>全部字段</span>
              </Radio>
              <Radio style={radioStyle} value='custom'>
                <span style={{ fontWeight: 'normal' }}>自定义</span>
                {way === 'custom' ?  <Select
                  getPopupContainer={() => document.body}
                  value={lists || []}
                  dropdownClassName="gradation-value-select-dropdown"
                  dropdownMatchSelectWidth={false}
                  style={{ height: 32, width: 212, display: 'block', margin: '5px 0 0 20px' }}
                  dropdownStyle={{ minWidth: 120, maxWidth: 256 }}
                  openSearch
                  mode='multiple'
                  showSearch
                  notFoundContent={noDataTip}
                  maxTagPlaceholder={omittedValues => <span title={omittedValues.join(',')}>+{omittedValues.length}...</span>}
                  maxTagCount={1}
                  placeholder="请选择字段"
                  onChange={this.onSelectChange.bind(this, item, index, 'effect_options')}
                >
                  { fields.map((f, i) => <Select.Option
                    disabled={item.dataset_field_id === f.dataset_field_id && item.col_type === f.col_type} // 自己禁用
                    key={`effect-custom-option-${i}`}
                    value={f.alias}>
                    {f.alias}
                  </Select.Option>)}
                </Select> : null}
              </Radio>
            </Radio.Group>
          }
          {
            [BAR, GRADATION].indexOf(type) > -1 && <Radio.Group onChange={this.onChangeEffectRange.bind(this, index)} value={way || 'default'}>
              <Radio value='default'>
              默认
              </Radio>
            </Radio.Group>
          }
        </div>
      </div>
    )
    return (
      <div className="cell" style={{ width: 50, flex: 0, flexShrink: 0 }}>
        <Dropdown
          trigger={['click']}
          overlay={configMenu}
          placement='bottomLeft'
          visible={rangeVisible}
          onVisibleChange={this.handleChangeVisible.bind(this, index, 'rangeVisible')}
        >
          <div className="effect-range-wrapper">
            <span>作用范围</span>
          </div>
        </Dropdown>
      </div>
    )
  }

  onChangeEffectRange = (index, e) => {
    const { conditions } = this.state
    const { value } = e.target
    if (conditions[index].effect_options) {
      conditions[index].effect_options.way = value
      conditions[index].effect_options.lists = []
    } else {
      conditions[index].effect_options = {
        way: 'default',
        lists: []
      }
      conditions[index].effect_options.way = value
    }
    this.setState({
      conditions
    })
  }

  handleChangeVisible = (index, type, status) => {
    const { conditions } = this.state
    if (status) {
      conditions[index][type] = status
      this.setState({
        conditions
      })
    }
  }

  clickBody = (e) => {
    const { conditions } = this.state
    const parent = $(e.target).parents('.table-cell-config-color-picker-popover-container')
    const isDropdownParent = $(e.target).parents('.cells-dropdown-overlay').length > 0 || $(e.target).hasClass('cells-dropdown-overlay')
    const isDropdownTrigger = $(e.target).hasClass('ant-dropdown-trigger') || $(e.target).parents('.ant-dropdown-trigger').length > 0
    const isColorSelect = $(e.target).closest('.gradation-color-select-dropdown').length > 0 || $(e.target).closest('.gradation-value-select-dropdown').length > 0

    if (($(parent).length === 0 && !isDropdownParent && !isDropdownTrigger && !isColorSelect) || (isDropdownTrigger && this.enableHidden)) {
      this.enableHidden = false
      if (_.find(conditions, c => c.visible === true) || _.find(conditions, c => c.rangeVisible === true)) {
        conditions.forEach((c) => {
          c.visible = false
          c.rangeVisible = false
        })
        this.setState({
          conditions
        })
      }
    } else if (isDropdownTrigger && !this.enableHidden) {
      this.enableHidden = true
    }
  }
  // 确定颜色选择
  handleConfirmColorChange = (index, type, color, barType) => {
    const { conditions } = this.state
    const newStyles = { ...conditions[index].styles }

    if (type === 'color' || type === 'background') {
      newStyles[type] = color
    }
    if (type === 'gradation_colors' && color) {
      newStyles[type] = color.split(',')
    }

    if (type === 'barColor') {
      const colorIndex = barType === 'negative' ? 0 : 1
      const newColors = [...newStyles.gradation_colors]
      newColors[colorIndex] = color
      newStyles.gradation_colors = newColors
    }

    conditions[index] = {
      ...conditions[index],
      styles: newStyles
    }
    this.setState({
      conditions
    })
  }

  handleConfirmGradationChange = (index, type, innerIndex, value, callback) => {
    const { conditions } = this.state
    const newConditions = [...conditions]
    const newStyles = { ...conditions[index].styles }

    if (type === 'value') {
      const originValue = [...conditions[index].value]

      if (value === 'fixed') {
        originValue[innerIndex] = ''
      } else {
        originValue[innerIndex] = value
      }

      if (_.isFunction(callback)) {
        callback([...conditions[index].value], originValue, innerIndex)
      }

      newConditions[index] = {
        ...conditions[index],
        value: originValue,
      }
    }

    if (type === 'color') {
      newStyles.gradation_colors = [...newStyles.gradation_colors]
      newStyles.gradation_colors[innerIndex] = value

      newConditions[index] = {
        ...conditions[index],
        styles: newStyles,
      }
    }

    this.setState({
      conditions: newConditions,
    })
  }

  handleConfirmBarChange = (index, value) => {
    const { conditions } = this.state
    if (conditions[index].value === value) return

    const newConditions = [...conditions]

    newConditions[index] = {
      ...conditions[index],
      value,
    }

    this.setState({
      conditions: newConditions,
    })
  }

  // 隐藏颜色选择器 并还原为上一次确定后的颜色
  handleHideColorPickerPopover = () => {
    // 触发关闭popover
    const overlay = $('.cells-dropdown-overlay')[0]
    overlay && overlay.dispatchEvent(new CustomEvent('mousedown', { bubbles: true }))
  };


  handleChangeStyle = (index, item, type, e) => {
    const { conditions } = this.state
    e.preventDefault()
    let newStyles = { ...conditions[index].styles }
    if (type === 'style') {
      newStyles = {
        ...newStyles,
        ...item,
        color: item.color,
        background: item.background
      }
    } else if (type === 'icon') {
      if (item.icon) {
        //修改icon
        newStyles.icon = item.icon
      } else {
        //修改颜色
        newStyles.color = item.background
      }
    }
    conditions[index] = {
      ...conditions[index],
      styles: newStyles
    }
    this.setState({
      conditions
    })
  }

  renderConditionsValue = (item, index) => {
    if (item.type === GRADATION) {
      return this.renderGradationCondition(item, index)
    }
    if (item.type === BAR) {
      return this.renderBarCondition(item, index)
    }
    const { col_type, operator } = item
    const type = item.field_type
    const nullType = isNullType(operator)
    switch (type) {
      case '枚举':
      case '字符串':
      case '数值':
        if (col_type === 'dim' && !nullType) {
          return this.renderDimCondition(item, index)
        } else {
          return this.renderNumCondition(item, index)
        }
      case '日期':
        if (col_type === 'dim') {
          return this.renderDateCondition(item, index)
        } else {
          return this.renderNumCondition(item, index)
        }
      default:
        return null
    }
  }

  renderNumCondition = (item, index) => {
    const { operator, value } = item
    let element
    switch (operator) {
      case 'between':
        element = (
          <div className="cell between" style={{ marginRight: 8, flex: 1 }}>
            <Input
              type="number"
              value={value[0] ? value[0] : ''}
              onChange={this.handleNumChange.bind(this, index, 'min')}
            />
            <span>~</span>
            <Input
              type="number"
              value={value[1] ? value[1] : ''}
              onChange={this.handleNumChange.bind(this, index, 'max')}
            />
          </div>
        )
        break
      // 为空不为空时无需输入框
      case 'is null':
      case 'is not null':
        element = null
        break
      // 默认情况显示单个输入框
      default:
        element = (
          <div className="cell single" style={{ marginRight: 8, flex: 1 }}>
            <Input
              type="number"
              placeholder="请输入数值"
              value={value[0] ? value[0] : ''}
              onChange={this.handleNumChange.bind(this, index, 'value')}
            />
          </div>
        )
        break
    }
    return element
  }

  renderGradationCondition = (item, index) => {
    const { operator } = item

    return (
      <div className="cell dimension" style={{ marginRight: 8, flex: 1 }}>
        <Select
          getPopupContainer={() => this.conditionsWrapper || document.body}
          value={operator || ''}
          onChange={this.handleGradationTypeChange.bind(this, index)}
        >
          {
            GRADATION_TYPES.map(gradationType => (
              <Select.Option key={`gradation-types-${gradationType.value}`} value={gradationType.value}>{gradationType.text}</Select.Option>
            ))
          }
        </Select>
      </div>
    )
  }

  renderBarCondition = (item, index) => {
    const { operator } = item

    return (
      <div className="cell dimension" style={{ marginRight: 8, flex: 1 }}>
        <Select
          getPopupContainer={() => this.conditionsWrapper || document.body}
          value={operator || ''}
          onChange={this.onSelectChange.bind(this, item, index, 'barOperator')}
        >
          {
            BAR_TYPES.map(barPositionType => (
              <Select.Option key={`gradation-types-${barPositionType.value}`} value={barPositionType.value}>{barPositionType.text}</Select.Option>
            ))
          }
        </Select>
      </div>
    )
  }

  renderDimCondition = (item, index) => {
    const { fieldsOption } = this.state
    const { operator, value: colValue } = item
    const selectType = isMultiple(operator) ? 'multiple' : 'single'
    const selectValue = (selectType === 'multiple') ? (colValue || []) : colValue[0]
    const options = fieldsOption[item.dataset_field_id]
    return (
      <div className="cell dimension" style={{ marginRight: 8, flex: 1 }}>
        <Select
          maxTagPlaceholder={omittedValues => <span title={omittedValues.join(',')}>+{omittedValues.length}...</span>}
          getPopupContainer={() => this.conditionsWrapper || document.body}
          value={selectValue || ''}
          openSearch
          mode={selectType}
          showSearch
          notFoundContent={noDataTip}
          maxTagCount={1}
          onChange={this.handleDimChange.bind(this, index, selectType === 'multiple')}
        // fixContainer={document.body}
        >
          {
            options && options.map((dimension, i) => (
              <Select.Option key={`dim-values-${i}`} value={dimension}>{dimension}</Select.Option>
            ))
          }
        </Select>
      </div>
    )
  }
  // 根据时间取值更新colValue
  _getOperatorFromDateDescription = (item) => {
    const { date_operator_type, dynamic_date, range_date, daysValue } = item
    let { value, operator } = item
    switch (date_operator_type) {
      // 动态时间段
      case 'dynamic':
        if (dynamic_date === 'fromDay') {
          operator = 'far'
          //转成数字
          value = [+daysValue]
        } else {
          const parseOpts = dynamic_date.split('&')
          operator = parseOpts[0]
          if (operator !== '=') {
            value = [+parseOpts[1]]
          } else {
            value = [parseOpts[1]]
          }
        }
        break
      // 静态
      case 'static':
        operator = 'between'
        value = range_date
        break
      case 'value':
        operator = 'is null'
        value = []
        break
      default:
        break
    }
    return {
      operator,
      value
    }
  }
  // 日期变化
  handleDate = (index, key, option) => {
    let optValue
    // 根据key类型选择不同的option取值方式
    if (key === 'range_date') {
      optValue = option
    } else if (key === 'dynamic_date') {
      optValue = option
    } else {
      optValue = option.target.value
    }
    this.setState((prevState) => {
      const { conditions } = prevState
      // 先更新KEY对应的值
      conditions[index][key] = optValue
      // 再更新 colValue 和 operator
      conditions[index] = {
        ...conditions[index],
        ...this._getOperatorFromDateDescription(conditions[index])
      }
      return { conditions }
    })
  }
  renderDateCondition = (item, index) => {
    const { date_operator_type, operator, dynamic_date, daysValue, range_date } = item
    let element
    switch (date_operator_type) {
      case 'dynamic': {
        const suffix = dynamic_date === 'fromDay' ? [
          (
            <div className="cell form" key={`date-rule-dynamic-date-input-${index}`} style={{ width: 48, marginRight: 8, flex: 1 }}>
              <div className="form-group" style={{ flexDirection: 'row' }}>
                <Input
                  type="number"
                  min={0}
                  value={daysValue}
                  onChange={this.handleDate.bind(this, index, 'daysValue')}
                />
                天
              </div>
            </div>
          )
        ] : []
        element = [(
          <div className="cell" key={`date-rule-dynamic-date-${index}`} style={{ width: dynamic_date !== 'fromDay' ? 130 : 70, marginRight: 8, flex: dynamic_date !== 'fromDay' ? 1 : 0, flexBasis: dynamic_date !== 'fromDay' ? 130 : 70 }}>
            <Select
              getPopupContainer={() => this.conditionsWrapper || document.body}
              width={dynamic_date !== 'fromDay' ? 130 : 70}
              value={dynamic_date}
              onChange={this.handleDate.bind(this, index, 'dynamic_date')}
            // fixContainer={document.body}
            >
              <Select.Option value="fromDay">距今</Select.Option>
              <Select.Option value="from_week&0">本周</Select.Option>
              <Select.Option value="from_week&1">上周</Select.Option>
              <Select.Option value="from_month&0">本月</Select.Option>
              <Select.Option value="from_month&1">上月</Select.Option>
              <Select.Option value="from_month&-1">下月</Select.Option>
              <Select.Option value="from_quarter&0">本季度</Select.Option>
              <Select.Option value="from_quarter&1">上季度</Select.Option>
              <Select.Option value="from_quarter&-1">下季度</Select.Option>
              <Select.Option value="from_year&0">本年</Select.Option>
              <Select.Option value="from_year&1">去年</Select.Option>
              <Select.Option value="from_year&-1">明年</Select.Option>
              <Select.Option value="" title="全部时间">全部时间</Select.Option>
            </Select>
          </div>
        ), ...suffix]
        break
      }
      case 'static':
        element = (
          <div className="cell" style={{ width: 130, marginRight: 8, flex: 1 }}>
            <DatePicker
              single={false}
              value={range_date}
              onSelected={this.handleDate.bind(this, index, 'range_date')}
              iconStyle={{ right: '-2px', height: 30 }}
            />
          </div>
        )
        break
      case 'value':
        element = (
          <div className="cell operator" style={{ width: 130, marginRight: 8, flex: 1 }}>
            <Select
              getPopupContainer={() => this.conditionsWrapper || document.body}
              value={operator || ''}
              onChange={this.onSelectChange.bind(this, item, index, 'operator')}
            // fixContainer={document.body}
            >
              <Select.Option value="is null">为空值</Select.Option>
              <Select.Option value="is not null">不为空值</Select.Option>
            </Select>
          </div>
        )
        break
      default:
        element = null
        break
    }
    return element
  }

  renderOperatorItem(item, index) {
    if (item.type === GRADATION) {
      return (
        <div className="cell" style={{ width: 110, flex: 0, flexShrink: 0, flexBasis: 110 }}>
          <div style={{ fontSize: 12, textAlign: 'right' }}>
            <span>色阶类型</span>
          </div>
        </div>
      )
    }

    if (item.type === BAR) {
      return (
        <div className="cell" style={{ width: 110, flex: 0, flexShrink: 0, flexBasis: 110 }}>
          <div style={{ fontSize: 12, textAlign: 'right' }}>
            <span>坐标轴位置</span>
          </div>
        </div>
      )
    }

    const { field_type: type } = item
    let content

    switch (type) {
      case '枚举':
      case '字符串':
      case '数值':
        if (item.col_type === 'dim') {
          content = [...DIM_OPERATORS]
        } else {
          content = [...NUM_OPERATORS]
        }
        break
      case '日期':
        if (item.col_type === 'dim') {
          content = [...DATE_OPERATOR_TYPES]
        } else {
          content = [...NUM_OPERATORS]
        }
        break
      default:
        content = []
    }
    const operatorType = type === '日期' && item.col_type === 'dim' ? 'date_operator_type' : 'operator'
    return this.generateOperatorSelect(item, index, content, operatorType)
  }

  generateOperatorSelect = (item, index, operators, operatorType) => {
    const { operator, date_operator_type } = item
    const selectLen = isNullType(operator) && operatorType !== 'date_operator_type' ? '248px' : '110px'
    return (
      <div className="cell" style={{ width: selectLen, flex: isNullType(operator) && operatorType !== 'date_operator_type' ? 1 : 0, flexShrink: 0, flexBasis: selectLen }}>
        <Select
          getPopupContainer={() => this.conditionsWrapper || document.body}
          value={operatorType === 'operator' ? operator : date_operator_type}
          style={{ height: 32 }}
          onChange={this.onSelectChange.bind(this, item, index, operatorType)}
        >
          {operators.map((f, i) => <Select.Option
            key={`cells-config-operators-${i}`}
            value={f.value}>{f.text}</Select.Option>)}
        </Select>
      </div>
    )
  }
}

export default CellsConfig
